import React from "react";
import PropTypes from "prop-types";
import { PropertyBadgesContainerWrapper } from "./PropertyBadgesContainer.styles";
import PropertyStatusBadge from "../PropertyStatusBadge/PropertyStatusBadge";
import { getPropertyStatusBadge } from "../../utils/propertyStatusUtils";
import { maximumYellow400, scarpaGray800 } from "StylesConstants";
import { isDefaultCountry } from "../../utils/utils";

const PropertyBadgesContainer = ({ inventoryTypeId = null, hasThreeChecks = null }) => {
  const badgeConfig = inventoryTypeId ? getPropertyStatusBadge(inventoryTypeId) : null;
  const isCaptured = inventoryTypeId === 2 || inventoryTypeId === 5;
  const showPreventaBadge = isCaptured && hasThreeChecks === 0 && !isDefaultCountry();

  const hasMultipleBadges = showPreventaBadge && badgeConfig;

  return (
    <PropertyBadgesContainerWrapper>
      {showPreventaBadge && (
        <PropertyStatusBadge
          label="Preventa"
          backgroundColor={maximumYellow400}
          textColor={scarpaGray800}
          fontSize="14px"
          $isFirst={true}
          $isLast={!hasMultipleBadges}
          $hasMultipleBadges={hasMultipleBadges}
        />
      )}
      {badgeConfig && (
        <PropertyStatusBadge
          label={badgeConfig.label}
          backgroundColor={badgeConfig.backgroundColor}
          textColor={badgeConfig.textColor}
          toolTipMessage={badgeConfig.toolTipMessage}
          fontSize="14px"
          $isFirst={!hasMultipleBadges}
          $isLast={true}
          $hasMultipleBadges={hasMultipleBadges}
        />
      )}
    </PropertyBadgesContainerWrapper>
  );
};

PropertyBadgesContainer.propTypes = {
  inventoryTypeId: PropTypes.number,
  hasThreeChecks: PropTypes.number,
};

export default PropertyBadgesContainer;

